"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const GuidesButton_1 = __importDefault(require("../../../atoms/GuidesButton"));
const TextFormattingPanel_1 = __importDefault(require("../../../molecules/TextFormattingPanel"));
const ToolsMode_1 = __importDefault(require("../../../templates/ToolsMode"));
const providers_1 = require("../../../providers");
const bridge_1 = require("@completeanatomy/bridge");
const ui_1 = require("@completeanatomy/ui");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const animation_1 = require("../../../utils/animation");
function ToolTextModePage() {
    const [isUIHidden, toggleUIHidden] = (0, ui_1.useToggleState)(false);
    const [{ isGuidesAvailable, isGuidesExpanded }] = (0, providers_1.useGuidesContext)();
    const bridge = (0, bridge_1.useBridge)();
    (0, react_1.useEffect)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: bridge_schema_1.ToolType.StickyText,
            currentOptions: { type: bridge_schema_1.ToolType.StickyText },
        });
    }, [bridge]);
    const isGuidesButtonVisible = isGuidesAvailable && !isGuidesExpanded && !isUIHidden;
    return ((0, jsx_runtime_1.jsx)(providers_1.RichTextProvider, { "data-e2e": 'ToolTextModePage_RichTextProvider', children: (0, jsx_runtime_1.jsx)(ToolsMode_1.default, { disableModelInteractions: true, title: (0, jsx_runtime_1.jsx)(TextFormattingPanel_1.default, {}), onToggleUI: toggleUIHidden, selectedType: bridge_schema_1.ToolType.StickyText, "data-e2e": 'ToolTextModePage_ToolsModeTemplate', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isGuidesButtonVisible, timeout: 300, mountOnEnter: true, unmountOnExit: true, appear: true, "data-e2e": 'ToolTextModePage_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledGuidesButton, { "data-e2e": 'ToolTextModePage_StyledGuidesButton' }) }) }) }));
}
exports.default = (0, react_1.memo)(ToolTextModePage);
const StyledGuidesButton = (0, styled_components_1.default)(GuidesButton_1.default) `
  position: absolute;
  bottom: 20px;
  left: 15px;

  ${(0, animation_1.SlideDown)('130%')}
`;
